module.exports = __webpack_public_path__ + "img/themes.a9fc6a2a.png";